import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import myshop from "../../assets/image/makrandsir.jpg"
import "../../index.css"
import Faq from '../Faq/Faq'
import Services from '../Services/Service'
import OtherPageTopBanner from '../../Herosection/Components/OtherPageTopBanner';
import { useLocation } from 'react-router-dom';

function About() {

  const location = useLocation();
  const path = location.pathname;

  const getTitle = () => {
    if (path === "/services") {
      return "Our Services";
    } else {
      return "About Us";
    }
  };
  return (
    <>

{path === "/about" && (
        <OtherPageTopBanner title="About Us" />
      )}
{/* <OtherPageTopBanner  title={getTitle()} /> */}

      <div className="container-fluid px-md-5 my-5">




      <div className="row align-items-center">
        <div className="col-md-5">
          <img data-aos="fade-right" data-aos-once="false"
            src={myshop} 
            alt="AC Service" 
            className="img-fluid rounded shadow-lg w-100" style={{height:"450px"}} 
          />
        </div>
        <div className="col-md-7 text-start" >
          <h2 className="text-primary fw-bold display-4"  data-aos="fade-left" data-aos-once="false">About Us?</h2>
          <p className="text-dark fs-5 "  data-aos="fade-left" data-aos-once="false" >
          Innovations Enterprises, founded by Makrand K. Gadre, is a leading name in the air conditioning industry, committed to delivering excellence through smart engineering and superior service. We specialize in two core areas:
          </p>
          <h1 className="text-dark fs-5 fw-bold"  data-aos="fade-left" data-aos-once="false" >1. AC System Design Consultation (Chargeable Service)</h1>
          <p className="text-dark fs-6"  data-aos="fade-left" data-aos-once="false" >We begin by analyzing your site with detailed drawings to calculate the exact heat load. Based on this, we determine the total tonnage and recommend the best types of air conditioning systems. Our design includes:</p>
          <ul className="list-unstyled mb-0"  data-aos="fade-up" data-aos-once="false">
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Placement layout for indoor and outdoor units</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Ducting layout for optimal air throw</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Copper piping plans between indoor and outdoor units</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Cabling and drain piping sizes and layout</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Aluminium grills, diffusers, and MS stands</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Required civil work and electrical load planning</li>
              <li className="mb-2"><span className="text-success fw-bold">✔</span> Air conditioner control panel positioning</li>  
            </ul>
            
            <h1 className="text-dark fs-5 fw-bold"  data-aos="fade-left" data-aos-once="false" >2. AC Supply & Installation</h1>
          <p className="text-dark fs-6"  data-aos="fade-left" data-aos-once="false" >We also provide complete turnkey solutions, from supply to installation. Upon receiving your site drawings and connecting with your architects and consultants, we conduct a site review and then submit a detailed quotation tailored to your needs.</p>
          

          {/* <button className="btn btn-primary mt-4 px-4 py-2 fs-5 shadow">Learn More</button> */}
        </div>
      </div>
    </div>  

    </>
  )
}

export default About